export enum PortalPageStatus {
    Draft,
    Published,
    Deleted
}